































import Vue from 'vue';
import VeBar from 'v-charts/lib/bar.common';
import customerClient from '../../../apis';
import customerVuex from '../../../vuex/common';

export default Vue.extend({
  mixins: [customerVuex],
  components: {
    VeBar,
  },
  data() {
    return {
      loadingProvinceData: true,
      loadingCityData: true,
      legend: {
        show: false,
      },
      chartProvinceData: {
        columns: ['province', 'count'],
        rows: [],
      },
      chartCityData: {
        columns: ['city', 'count'],
        rows: [],
      },
      chartSettings: {
        metrics: ['count'],
        labelMap: {
          count: '用户数',
        },
        dataOrder: {
          label: 'count',
          order: 'desc',
        },
        label: {
          show: true,
          textStyle: {
            fontSize: '12',
            color: '#000',
          },
          position: 'right',
        },
      },
      colors: ['#00A287'],
      chartExtend: {
        grid: {
          containLabel: true,
          right: '10%',
        },
        tooltip: {
          show: false,
        },
        series: {
          barWidth: 12,
          barGap: '100%',
        },
        xAxis: {
          show : false,
        },
        yAxis: {
          splitLine: {show: false},
          axisLine: {show: false}, 
          axisTick: {show: false},
        },
      },
    };
  },
  methods: {
    getProvinceData() {
      customerClient.getProvinceGroup(this.customerState.customerQuery).success((r) => {
        this.chartProvinceData.rows = r.data.filter(((i: any) => i.province !== '')).slice(0, 10);
        this.loadingProvinceData = false;
      }).error((e) => {
        this.$Message.error(e.toString());
      });
    },
    getCityData() {
      customerClient.getCityGroup(this.customerState.customerQuery).success((r) => {
        this.chartCityData.rows = r.data.filter(((i: any) => i.city !== '')).slice(0, 10);
        this.loadingCityData = false;
      }).error((e) => {
        this.$Message.error(e.toString());
      });
    },
  },
  mounted() {
    this.getCityData();
    this.getProvinceData();
  },
});
